import { Injectable } from '@angular/core';

import {
    OperationType,
    QualityCheckInBookingType,
    ResponseForConvertListOperationAfx2jsonType
} from "@afidium/ts-facade";
import { CodeForOperationType } from "@afidium/ts-facade/model/codeForOperationType";
import { StatusForControlWithinOperationType } from "@afidium/ts-facade/model/statusForControlWithinOperationType";

@Injectable({
    providedIn: 'root'
})
export class QualityCheckToolsService {

    public getMergedQualityCheckItems(
        qualityCheckResponse: ResponseForConvertListOperationAfx2jsonType,
        qualityCheckInBooking: QualityCheckInBookingType): OperationType[] {

        const hasQualityCheckItemsInBooking: boolean = Boolean(qualityCheckInBooking?.operationsLastPerformed?.operationArray?.length);
        const hasQualityCheckItemInResponse: boolean = Boolean(qualityCheckResponse.operationArray?.length);

        if (hasQualityCheckItemsInBooking && hasQualityCheckItemInResponse) {
            const updatedOperationCodes: string[] =
                [
                    //set is to remove dupes
                    ...new Set(
                        qualityCheckResponse.operationArray.map((operation: OperationType): string => operation.code)
                    )
                ];
            const notUpdatedOperationArray: OperationType[] = qualityCheckInBooking.operationsLastPerformed.operationArray
                .filter((operation: OperationType): boolean => !updatedOperationCodes.includes(operation.code));
            return [
                ...notUpdatedOperationArray,
                ...qualityCheckResponse.operationArray
            ];
        }
        if (!hasQualityCheckItemsInBooking && hasQualityCheckItemInResponse) {
            return qualityCheckResponse.operationArray;
        }
        if (hasQualityCheckItemsInBooking && !hasQualityCheckItemInResponse) {
            return qualityCheckInBooking.operationsLastPerformed.operationArray;
        }
    }

    public getWorstStatusFormOperationArray(operationArray: OperationType[]): StatusForControlWithinOperationType {
        return this.getWorstStatus(operationArray.map((operation: OperationType): StatusForControlWithinOperationType => operation.status));
    }

    private getWorstStatus(statuses: StatusForControlWithinOperationType[]): StatusForControlWithinOperationType {
        const OPERATION_STATUS_PRIORITIZED: StatusForControlWithinOperationType[] = [
            'ACTION_REQUIRED',
            // @ts-ignore
            'CONTROL_FAILED',
            // @ts-ignore
            'CONTROL_ALERT',
            'ACTION_PERFORMED',
            'NO_ACTION_REQUIRED',
        ];
        let output: StatusForControlWithinOperationType;
        OPERATION_STATUS_PRIORITIZED.forEach((status: StatusForControlWithinOperationType): void => {
            if (statuses.includes(status) && !output) {
                output = status;
            }
        });
        return output;
    }
}
